module.exports = __webpack_public_path__ + "img/twitter-logo.e2f79a34.svg";